import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import ProgressBar from '../common/ProgressBar';
import { questions } from '../../data/questions';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.xl};
  background-color: ${props => props.theme.colors.background};
`;

const ProgressContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing.xl};
`;

const QuestionContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

const Question = styled.h2`
  font-size: 1.35rem;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: ${props => props.theme.spacing.lg};
  text-align: center;
  font-weight: 600;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.md};
`;

const Option = styled(motion.button)`
  background-color: white;
  border: 2px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: ${props => props.theme.spacing.lg};
  text-align: left;
  font-size: ${props => props.theme.typography.fontSize.body};
  color: ${props => props.theme.colors.textPrimary};
  transition: all ${props => props.theme.transitions.default};
  cursor: pointer;
  min-height: 44px;
  display: flex;
  align-items: center;

  &:hover {
    border-color: ${props => props.theme.colors.primary};
    transform: translateY(-2px);
  }

  &.selected {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.backgroundAlt};
  }
`;

const QuestionScreen = ({ questionId, onAnswer, progress }) => {
  const currentQuestion = questions.find(q => q.id === questionId);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [email, setEmail] = React.useState('');
  const [emailError, setEmailError] = React.useState('');

  if (!currentQuestion) return <div>Frage nicht gefunden.</div>;

  if (currentQuestion && currentQuestion.id === 'question-9') {
    currentQuestion.text = 'Haben Sie bereits eine Hautpflegeroutine?';
  }

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    onAnswer(questionId, option);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError('');
  };

  const validateEmail = (email) => {
    // Simple email regex
    return /^\S+@\S+\.\S+$/.test(email);
  };

  const handleEmailSubmit = () => {
    if (!validateEmail(email)) {
      setEmailError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }
    onAnswer(questionId, email);
  };

  return (
    <Container>
      <ProgressContainer>
        <ProgressBar progress={progress} />
      </ProgressContainer>

      <QuestionContainer
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
      >
        <Question>{currentQuestion.text}</Question>

        {currentQuestion.type === 'email' ? (
          <div style={{ maxWidth: 400, margin: '0 auto', width: '100%' }}>
            <label style={{ fontSize: '1.1rem', color: '#2C3E50', marginBottom: 8, display: 'block', fontWeight: 600 }}>
              Dürfen wir Ihnen personalisierte Hautpflegeratgeber und mehr per E-Mail senden?
            </label>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder={currentQuestion.placeholder ? currentQuestion.placeholder + ' (optional)' : 'Ihre E-Mail (optional)'}
              style={{
                width: '100%',
                padding: '1rem',
                fontSize: '1rem',
                borderRadius: '8px',
                border: `2px solid ${emailError ? '#dc3545' : '#E9ECEF'}`,
                marginBottom: '1rem',
                boxSizing: 'border-box',
              }}
              autoFocus
            />
            {emailError && (
              <div style={{ color: '#dc3545', marginBottom: '1rem', fontSize: '0.95rem' }}>{emailError}</div>
            )}
            <button
              onClick={() => onAnswer(questionId, email)}
              style={{
                width: '100%',
                background: '#4A6FA5',
                color: 'white',
                padding: '1rem',
                borderRadius: '8px',
                fontSize: '1.1rem',
                fontWeight: 600,
                border: 'none',
                cursor: 'pointer',
                transition: 'background 0.2s',
              }}
            >
              Weiter
            </button>
            <button
              onClick={() => onAnswer(questionId, '')}
              style={{
                width: '100%',
                background: '#E8B4B8',
                color: '#2C3E50',
                padding: '1rem',
                borderRadius: '8px',
                fontSize: '1.1rem',
                fontWeight: 600,
                border: 'none',
                cursor: 'pointer',
                marginTop: '0.5rem',
                transition: 'background 0.2s',
              }}
            >
              Weiter ohne E-Mail
            </button>
          </div>
        ) : (
          <OptionsContainer>
            {currentQuestion.options.map((option, index) => (
              <Option
                key={index}
                onClick={() => handleOptionSelect(option)}
                className={selectedOption === option ? 'selected' : ''}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {option}
              </Option>
            ))}
          </OptionsContainer>
        )}
      </QuestionContainer>
    </Container>
  );
};

export default QuestionScreen; 